const maxTextFieldLength = 50;

export const validatePassword = (values) => {
  const field = typeof values === 'object' ? values.password : values;
  let errorMessage = '';

  if (/[\sа-я]+/i.test(field)) {
    errorMessage = 'Use latin characters and special symbols except spaces';
  } else if (field.length < 8) {
    errorMessage = 'Password is too short, please use at least 8 characters';
  } else if (field.length > 30) {
    errorMessage = 'Password is too long, please use no more than 30 characters';
  }

  return errorMessage;
};

export const validateName = (values) => {
  const field = typeof values === 'object' ? values.firstName : values;
  let errorMessage = '';
  if (field.length > maxTextFieldLength) {
    errorMessage = `Please enter no more than ${maxTextFieldLength} characters`;
  }
  return errorMessage;
};

export const validateLastName = (values) => {
  const field = typeof values === 'object' ? values.lastName : values;
  let errorMessage = '';
  if (field.length > maxTextFieldLength) {
    errorMessage = `Please enter no more than ${maxTextFieldLength} characters`;
  }
  return errorMessage;
};

export const validateEmail = (values) => {
  const field = (typeof values === 'object' ? values.email : values) || '';
  let errorMessage = '';
  if (!field.trim()) {
    errorMessage = 'Please enter your email';
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(field.trim())) {
    errorMessage = 'Please enter a valid email address';
  } else if (field.length > 100) {
    errorMessage = 'Please enter no more than 100 characters';
  }
  return errorMessage;
};
